import React, { createContext, useState, useEffect } from 'react';
import UserApi from '../api/UserApi';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState({ isInitiative : true });
  const updateUserInfo = () => {
    UserApi.getUserLoginInfo().then(rslt => {
      if (rslt && rslt.user) setUser(rslt.user);
      else setUser({ isInitiative : false });
    })
  }
  useEffect(updateUserInfo, []);

  return (
    <UserContext.Provider value={{ user, setUser, updateUserInfo }}>
      {children}
    </UserContext.Provider>
  );
};

export default UserContext;
